export enum UseOfPremises {
    Residential = 1,
    Commercial = 2,
    Special = 3,
    Industrial = 4,
    ShopBoysQt = 5,
    Others = 6,
}